<template>
  <div style="font-size: 14px">
    <div class="img">
      <img :src="Frienddata.backgroundImg" alt="" />
      <img :src="Frienddata.avatar" alt="" />
      <div class="name">{{Frienddata.memberName}}</div>
    </div>
    <div class="qian">{{Frienddata.personSignature}}</div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
    <div>
      <div >
      <div class="content" v-for="(item,index) in thisYear" :key="index">
      <div class="time thisYear">
        <div v-if="d==item.sendTime.split('-')[2]&&m==item.sendTime.split('-')[1]">今天</div>
        <div v-if="d-item.sendTime.split('-')[2]===1&&m==item.sendTime.split('-')[1]">昨天</div>
        <div v-else v-show="!(d==item.sendTime.split('-')[2]&&m==item.sendTime.split('-')[1])"><span>{{item.sendTime.split('-')[2]}}</span><span>{{item.sendTime.split('-')[1]}}月</span></div>
      </div>
      <div style="display: flex;flex:1">
        <div class="list_img" v-if="item.contentType!==2">
          <img :class="item.imgList.length>1?'item1':'item'" v-show="index < 4" :src="items" alt="" v-for="(items,index) in item.imgList" :key="index" />
        </div>
        <div class="content_text van-multi-ellipsis--l3">
          <div :class="item.contentType==2?'text_color':''">{{item.textContent}}</div>
          <div v-if="item.imgList" class="length">共  {{item.imgList.length}}  张</div>
        </div>
      </div>
    </div>
    </div>
    <div >
      <div class="years" >{{y-1}}年</div>
      <div class="content" v-for="(item,index) in qiHan" :key="index">
      <div class="time qiHan">
        <span>{{item.sendTime.split('-')[2]}}</span><span>{{item.sendTime.split('-')[1]}}月</span>
      </div>
      <div style="display: flex;flex:1">
        <div class="list_img" v-if="item.contentType!==2">
          <img :class="item.imgList.length>1?'item1':'item'" v-show="index < 4" :src="items" alt="" v-for="(items,index) in item.imgList" :key="index" />
        </div>
        <div class="content_text van-multi-ellipsis--l3">
          <div :class="item.contentType==2?'text_color':''">{{item.textContent}}</div>
          <div v-if="item.imgList" class="length">共  {{item.imgList.length}}  张</div>
        </div>
      </div>
    </div>
    </div>
    <div >
      <div class="years" >{{y-2}}年</div>
      <div class="content" v-for="(item,index) in threeYearsAgo" :key="index">
      <div class="time threeYearsAgo">
        <span>{{item.sendTime.split('-')[2]}}</span><span>{{item.sendTime.split('-')[1]}}月</span>
      </div>
      <div style="display: flex;flex:1">
        <div class="list_img" v-if="item.contentType!==2">
          <img :class="item.imgList.length>1?'item1':'item'" v-show="index < 4" :src="items" alt="" v-for="(items,index) in item.imgList" :key="index" />
        </div>
        <div class="content_text van-multi-ellipsis--l3">
          <div :class="item.contentType==2?'text_color':''">{{item.textContent}}</div>
          <div v-if="item.imgList" class="length">共  {{item.imgList.length}}  张</div>
        </div>
      </div>
    </div>
    </div>
    </div>
  </van-list>
  </div>
</template>

<script>
import {timeFormat} from '../../utils/index'
export default {
  props: {
    href: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      corpId:'ww4002fb86c5d469b7',
      memberId:'Dong',
      page:1,
      pageCount:10,
      Frienddata:{},
      list:[],
      loading: false,
      finished: false,
      y : new Date().getFullYear(),
      m : new Date().getMonth() + 1,
      d : new Date().getDate(),
      thisYear:[], //今年
      qiHan:[], //去年
      threeYearsAgo:[], //前年
      sameDay:[], //今天
      thisYearyesterday:[],  //昨天
      thisYearyesterday:[],  //昨天
      arr:[],
    }
  },
  created(){
    this.FriendCircle()
    this.Listpage()
  },
  methods: {
    FriendCircle(){
      this.$http.get('/scrm/v1/wxcp-friend-circle/p/findFriendCircleConfig',{
        params:{
          corpId:this.href.corpId,
          memberId:this.href.memberId
        }
      }).then(res=>{
        if(res.code===1){
           this.Frienddata=res.data
        }
      })
    },
    gridview(){
      if(this.list.length!==0){
        let list = this.list
        this.threeYearsAgo=[]
        this.qiHan=[]
        this.thisYear=[]
        list.map(item=>{
          item.sendTime=timeFormat(item.sendTime,'yyyy-MM-dd')
          let yyyy = item.sendTime.split('-')[0]
          if(this.y == yyyy){
            this.thisYear.push(item)
          } else if((this.y - yyyy)==1){
            this.qiHan.push(item)
          }else{
            this.threeYearsAgo.push(item)
          }
          return item
        })
        document.getElementsByClassName('thisYear').forEach((item,index,self) => {
          for(let i = index+1; i < self.length; i++){
               if(self[i].innerText === item.innerText){
                  self[index+1].innerText=''
               }
            }
        })
        document.getElementsByClassName('qiHan').forEach((item,index,self) => {
          for(let i = index+1; i < self.length; i++){
               if(self[i].innerText === item.innerText){
                  self[index+1].innerText=''
               }
            }
        })
        document.getElementsByClassName('threeYearsAgo').forEach((item,index,self) => {
          for(let i = index+1; i < self.length; i++){
               if(self[i].innerText === item.innerText){
                  self[index+1].innerText=''
               }
            }
        })
       }
    },
    Listpage(){
      this.$http.get('/scrm/v1/wxcp-friend-circle/p/findH5ListByPage',{
        params:{
          corpId:this.href.corpId,
          memberId:this.href.memberId,
          page:this.page,
          pageCount:this.pageCount,
        }
      }).then(res=>{
        if(res.code===1){
          if(res.data.records.length!==0){
            this.list.push(...res.data.records)
            this.gridview()
            this.loading = false
           }else{
            //  this.List=[]
             this.finished = true
           }
           if (this.list.length >= res.total) {
              this.finished = true;		// 结束加载状态
            }
        }
      })
    },
    onLoad() {
      this.page++
      this.Listpage()
    },
  },
}
</script>
 
<style lang = "less" scoped>
.img {
  height: 50vh;
  width: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    &:nth-child(2) {
      width: 65px;
      height: 60px;
      position: absolute;
      bottom: -20px;
      right: 10px;
      border-radius: 6px;
    }
  }
  .name {
    color: #fff;
    position: absolute;
    bottom: 4%;
    right: 25%;
    font-weight: 600;
  }
}
.qian {
  margin-top: 25px;
  width: 100%;
  padding: 0 15px;
  text-align: right;
  line-height: 20px;
}
.years{
  font-size: 28px;
  padding: 15px 5px;
}
.content {
  padding: 20px 10px 10px 10px;
  display: flex;
  .time {
    width: 20%;
    font-size: 22px;
    span {
      &:nth-child(2) {
        font-size: 12px;
      }
    }
  }
  .list_img{
    width: 70px;
    height: 70px;
    .item{
      width: 100%;
      height: 100%;
    }
    .item1{
      width: 50%;
      height: 50%;
    }
  }
  .length{
    position: absolute;
    bottom:0;
    left: 0;
    color: #aaa;
    font-size: 12px;
  }
  .content_text {
    margin: 5px 10px;
    position: relative;
    flex: 1;
  }
  .text_color{
    width: 100%;
    height: 20px;
    background-color: #f7f7f7;
    line-height: 20px;
  }
}
</style>